import { HandWaveIcon } from './HandWaveIcon';

/**
 * author: Google
 * id 2AE6B41D-EC56-4851-BEB2-B6A22B1E9D44
 * name hand-wave
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-wave.svg
 * tags
 */
export const GreetingIcon = HandWaveIcon;
export default GreetingIcon